import { Button, COLOR_INFO_50, IconCoin, Text } from '@consumidor-positivo/aurora';
import './styles.scss';

type ExpenseInfoProps = {
  monthlyExpense: string;
  openEditModal: () => void;
};

export const ExpenseInfo = ({ monthlyExpense, openEditModal }: ExpenseInfoProps) => {
  return (
    <div className="mm-expense-info">
      <div className="mm-expense-info__values">
        <IconCoin rawColor={COLOR_INFO_50} />
        <div>
          <Text as="span" variant="body-large">
            Despesa Mensal:{' '}
          </Text>
          <Text as="span" variant="body-large" weight="bold" className="mm-expense-info__expanse">
            {monthlyExpense}
          </Text>
        </div>
      </div>
      <Button type="link" onClick={openEditModal}>
        Editar
      </Button>
    </div>
  );
};
